import { AxiosResponse } from "axios";
import { Axios } from "../Axios";
import { TypeAgencia } from "../../Models/Financeiro/Agencia";

export class AgenciaService {
    public listar(agencia: TypeAgencia): Promise<AxiosResponse<TypeAgencia[]>> {
        return Axios.post<TypeAgencia[]>(`agencia/listar`, agencia);
    }

    public inserir(agencia: TypeAgencia) {
        return Axios.post('Agencia/inserir', agencia);
    }

    public atualizar(agencia: TypeAgencia){
        return Axios.put<TypeAgencia>('Agencia/atualizar', agencia);
    }

    public ativar(codigoDaAgencia: number){
        return Axios.patch(`Agencia/ativar/${codigoDaAgencia}`);
    }

    public desativar(codigoDaAgencia: number){
        return Axios.patch(`Agencia/desativar/${codigoDaAgencia}`);
    }
}